/** The Jobs list's address: `?filter=` (opens on Today) and `?q=` survive a reload. */

export type JobsFilter = "today" | "week" | "all" | "archived";

export function validateJobsSearch(s: Record<string, unknown>): { q?: string | undefined; filter?: JobsFilter | undefined } {
  const f = s["filter"];
  return {
    q: typeof s["q"] === "string" && s["q"] ? s["q"] : undefined,
    filter: f === "today" || f === "week" || f === "all" || f === "archived" ? f : undefined,
  };
}

/** Tickets with no job: `?filter=held|set_aside` survives a reload (PRD 48 section 7). */
export type TicketsFilter = "held" | "set_aside";

/** Requests: `?state=to_review|made|set_aside` survives a reload (LOG-D-T16). */
export type RequestsState = "to_review" | "made" | "set_aside";

export function validateRequestsSearch(s: Record<string, unknown>): { state?: RequestsState | undefined } {
  const v = s["state"];
  return { state: v === "to_review" || v === "made" || v === "set_aside" ? v : undefined };
}

/** The form a request opens (`/dispatch/new?request=<id>`). */
export function validateFromRequestSearch(s: Record<string, unknown>): { request?: string | undefined } {
  const v = s["request"];
  return { request: typeof v === "string" && /^[0-9a-f-]{36}$/i.test(v) ? v : undefined };
}

export function validateTicketsSearch(s: Record<string, unknown>): { filter?: TicketsFilter | undefined } {
  const f = s["filter"];
  return { filter: f === "held" || f === "set_aside" ? f : undefined };
}
